import React from 'react';
// material
import { CssBaseline } from '@mui/material';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
//
import shape from './shape';
import palette from './palette';
import typography from './typography';
import breakpoints from './breakpoints';
import componentsOverride from './overrides';
import shadows, { customShadows } from './shadows';

// ----------------------------------------------------------------------

// eslint-disable-next-line react/prop-types
export default function ThemeConfig({ children }) {
  const themeConfig = createTheme({
    palette: { ...palette.light, mode: 'light' },
    shape,
    typography,
    breakpoints,
    shadows: shadows.light,
    customShadows: customShadows.light
  });
  themeConfig.components = componentsOverride(themeConfig);
  
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themeConfig}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}